import React from "react";
import { Router, Route } from "react-router";

import "./shared/config/global.js";

import Loading from "./features/auth/Loading";
import Login from "./features/auth/Login";
import ChooseProject from "./features/auth/ChooseProject";
import Customer from "./features/customer/Customer";
import Import from "./features/import/Import";
import ImportCustomer from "./features/import/ImportCustomer";
import ImportBillWater from "./features/import/ImportBillWater";
import ImportBillUnitUsed from "./features/import/ImportBillUnitUsed";
import ImportPaymentHistory from "./features/import/ImportPaymentHistory";
import Export from "./features/import/Export";
import RecordWaterUsage from "./features/water-usage/RecordWaterUsage";
import WaterUsageInfo from "./features/water-usage/WaterUsageInfo";

import TempRecordWaterUsage from "./features/water-usage/TempRecordWaterUsage";

import Billing from "./features/billing/Billing";
import RecordReceipt from "./features/billing/RecordReceipt";
import ReceiptAdjustment from "./features/billing/ReceiptAdjustment";
import RecordOther from "./features/billing/RecordOther";
import RecordBill from "./features/billing/RecordBill";
import RecordBillHistory from "./features/billing/RecordBillHistory";
import BillWater from "./features/billing/BillWater";
import Remittance from "./features/billing/Remittance";
import UsageHistory from "./features/billing/UsageHistory";
import CapitalPaymentInfo from "./features/billing/CapitalPaymentInfo";
import WaterPaymentInfo from "./features/billing/WaterPaymentInfo";
import WriteOfDept from "./features/billing/WriteOfDept";
import ListCutOf from "./features/billing/ListCutOf";

import BookBank from "./features/accounting/BookBank";
import Statement from "./features/accounting/Statement";
import GlReconcile from "./features/accounting/GlReconcile";
import Report from "./features/report/Report";

import Employee from "./features/user/Employee";
import Role from "./features/user/Role";
import CreateRole from "./features/user/CreateRole";
import UpdateRole from "./features/user/UpdateRole";

import ManageWater from "./features/settings/ManageWater";
import ProfileCode from "./features/settings/ProfileCode";
import InvoiceItemCode from "./features/settings/InvoiceItemCode";
import Logfile from "./features/settings/Logfile";
import Profile from "./features/settings/Profile";

import Letter from "./features/settings/document/Letter";
import InvoiceByRoom from "./features/settings/document/InvoiceByRoom";
import Receipt from "./features/settings/document/Receipt";
import ReceiptOther from "./features/settings/document/ReceiptOther";
import InvoiceOther from "./features/settings/document/InvoiceOther";

import DocReceipt from "./documents/pages/Receipt";
import DocReceiptOther from "./documents/pages/ReceiptOther";
import DocInvoiceOther from "./documents/pages/InvoiceOther";
import DocInvoiceByRoom from "./documents/pages/InvoiceByRoom";
import DocLetter from "./documents/pages/Letter";
const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={Loading} />
    <Route path="/login" component={Login} />
    <Route path="/choose-project" component={ChooseProject} />
    <Route path="/customer" component={Customer} />
    <Route path="/import" component={Import} />
    <Route path="/import-customer" component={ImportCustomer} />
    <Route path="/import-bill-water" component={ImportBillWater} />
    <Route path="/import-bill-unit-used" component={ImportBillUnitUsed} />
    <Route path="/import-payment-history" component={ImportPaymentHistory} />
    <Route path="/export" component={Export} />
    <Route path="/record-water-usage" component={RecordWaterUsage} />
    <Route path="/water-usage-info" component={WaterUsageInfo} />

    <Route path="/temp-record-water-usage" component={TempRecordWaterUsage} />

    <Route path="/billing" component={Billing} />
    <Route path="/record-receipt" component={RecordReceipt} />
    <Route path="/receipt-adjustment" component={ReceiptAdjustment} />
    <Route path="/record-other" component={RecordOther} />
    <Route path="/record-bill" component={RecordBill} />
    <Route path="/record-bill-history" component={RecordBillHistory} />
    <Route path="/bill-water" component={BillWater} />
    <Route path="/remittance" component={Remittance} />
    <Route path="/usage-history" component={UsageHistory} />
    <Route path="/capital-payment-info" component={CapitalPaymentInfo} />
    <Route path="/water-payment-info" component={WaterPaymentInfo} />
    <Route path="/write-of-dept" component={WriteOfDept} />
    <Route path="/cut-of" component={ListCutOf} />

    <Route path="/all-report" component={Report} />

    <Route path="/employee" component={Employee} />
    <Route path="/role" component={Role} />
    <Route path="/create-role" component={CreateRole} />
    <Route path="/update-role" component={UpdateRole} />

    <Route path="/manage-water" component={ManageWater} />
    <Route path="/profile-code" component={ProfileCode} />
    <Route path="/invoice-item-code" component={InvoiceItemCode} />
    <Route path="/logfile" component={Logfile} />
    <Route path="/profile" component={Profile} />
    <Route path="/bookbank" component={BookBank} />
    <Route path="/statement" component={Statement} />
    <Route path="/gl/reconcile" component={GlReconcile} />

    <Route path="/letter" component={Letter} />
    <Route path="/invoice-by-room" component={InvoiceByRoom} />
    <Route path="/receipt" component={Receipt} />
    <Route path="/receipt-other" component={ReceiptOther} />
    <Route path="/invoice-other" component={InvoiceOther} />

    <Route path="/doc/receipt" component={DocReceipt} />
    <Route path="/doc/receipt-other" component={DocReceiptOther} />
    <Route path="/doc/invoice-other" component={DocInvoiceOther} />
    <Route path="/doc/invoice-by-room" component={DocInvoiceByRoom} />
    <Route path="/doc/letter" component={DocLetter} />
  </Router>
);

export default Routes;
